module.exports = __webpack_public_path__ + "img/citySelect3.6736a656.png";